import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';

export interface FastAPIError {
  detail: string;
}

/**
 * Renders a toast message displaying the error
 * @param error the error object returned from a try-catch block
 * @param customMessage a custom error message
 */
const errorHandler = (error: unknown, customMessage?: string): void => {
  // Cast the error to a FastAPI error
  const fastError = error as AxiosError<FastAPIError>;

  // UI based handling
  if (customMessage) {
    // A custom error message will be displayed to the user
    toast.error(customMessage);
    error instanceof Error && console.error(error);
  } else if (fastError.response) {
    // The fast api error message will be displayed to the user
    toast.error(fastError.response.data.detail);
    console.error(fastError.response);
  } else {
    // The JS error message will be displayed to the user
    error instanceof Error && toast.error(error.message);
    console.error(error);
  }

  // Log it all to sentry
  Sentry.captureException(error);
};

export default errorHandler;
